window.onload = function () {
    var roundUpVariantId = 36538618773659;
    window.roundupChecking = false;
  	

    var selectedQty = jQuery341("input[id*='" + roundUpVariantId + "']").val();
    if (selectedQty) {
      jQuery341(".roundup_donation_amount").val(selectedQty);
    }
    function afterFinish(target) {
      var $target = jQuery341(target);
      if ($target.attr("href")) {
        window.location.href = $target.attr("href");
        return;
      }

      $target.trigger("click");
    }

    function handleRoundUp(ev) {
      if (window.roundupChecking) return true;
      console.log("checkout clicked...");
      ev.preventDefault();
      ev.stopPropagation();
      window.roundupChecking = true;
      var addRoundUp = jQuery341(".round_up_checkbox").prop("checked");
      var quantity = parseInt(jQuery341(".roundup_donation_amount").val());

      console.log("addRoundUp: " + addRoundUp);
      console.log("donation amount: " + quantity);
      jQuery341.getJSON("/cart.js", function (cart) {
        var roundProdExist = false;

        var cartQuantity = 0;
        jQuery341.each(cart.items, function (index, value) {
          if (value.id == roundUpVariantId) {
            cartQuantity = value.quantity;
            roundProdExist = true;
          }
        });

        if (addRoundUp && !roundProdExist) {
          var params = {
            type: "POST",
            url: "/cart/add.js",
            async: false,
            data: "quantity=" + quantity + "&id=" + roundUpVariantId,
            dataType: "json",
            success: function () {
              console.log("add success...");
              afterFinish(ev.target);
            },
          };
          jQuery341.ajax(params);
          console.log("add roundup prod");
        } else if (
          (!addRoundUp && roundProdExist) ||
          (addRoundUp && cartQuantity != quantity)
        ) {
          if (!addRoundUp) {
            quantity = 0;
          }
          
          jQuery341.ajax({
            type: "POST",
            url: "/cart/update.js",
            async: false,
            data: "updates[" + roundUpVariantId + "]="+quantity,
            dataType: "json",
            success: function () {
              console.log("update/remove success...");
              afterFinish(ev.target);
            },
          });
          
        } else {
          afterFinish(ev.target);
        }
      });

      return false;
    }

    jQuery341("body").on("click", 'button[name="checkout"]', handleRoundUp);
  };